import $ from 'jquery'

import form from '../../edit/form/form'

import * as date from '../../../../lib/date'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'
import generateSequence from '../../lib/generateSequence'
import refreshData from '../../lib/refreshData'

export function getName(){
  return 'anti-archive/tag'
}

export function getTableColumns(o,item){

  var totalMarkers =
    _.filter(
      o.data.antiArchive.markers,
      function(marker){
        if(marker.tag == item._id){
          return true
        } else {
          return false
        }
      }
    ).length

  var totalPublicMarkers =
    _.filter(
      o.data.antiArchive.markers,
      function(marker){
        if(marker.public && marker.tag == item._id){
          return true
        } else {
          return false
        }
      }
    ).length

  var sequence =
    _.find(o.data.antiArchive.sequences,function(sequence){
      return sequence.tag == item._id
    })

  if(sequence){
    var sequenceDate = date.format(sequence.date)
    var sequenceUser = sequence.user
  } else {
    var sequenceDate = null //date.format(new Date(0))
    var sequenceUser = null
  }

  var columns = [
    {
      id: 'de',
      value: item.de,
      type: o.type.text,
      width: 100,
    },
    {
      id: 'en',
      value: item.en,
      type: o.type.text,
      width: 100,
    },
    {
      id: 'fr',
      value: item.fr,
      type: o.type.text,
      width: 100,
    },
    {
      id: 'ru',
      value: item.ru,
      type: o.type.text,
      width: 100,
    },
    {
      id: 'public',
      value: item.public,
      type: o.type.toggle,
      width: 70,
    },
    {
      id: 'inFullSequence',
      value: item.inFullSequence,
      type: o.type.toggle,
      width: 70,
    },
    {
      id: 'markers',
      value: totalMarkers,
      type: o.type.number,
      width: 70,
    },
    {
      id: 'publicMarkers',
      value: totalPublicMarkers,
      type: o.type.number,
      width: 70,
    },
    {
      id: 'sequence',
      value: 'generateSequence',
      type: o.type.action,
      click: function(e){

        e.stopPropagation()

        if(item.public && totalPublicMarkers > 2){
          if(!o.generatingSequence){

            var sure = confirm('Generate sequence?')

            if(!sure){ return }

            o.generatingSequence = true

            generateSequence(item._id,function(error,result){
              o.generatingSequence = false
              if(error){
                console.log(error, result)
                alert('Generating sequence failed, try again later.')
              } else {
                alert('Sequence will be generated in background. It will take ca. 1 second per marker.')
              }
            })

          } else {
            alert('Generating sequence in progress, please wait.')
          }

        } else {
          alert('Generating sequences only works for public tags with 3 public markers minimum.')
        }

      }
    },
    {
      id: 'sequenceDate',
      value: sequenceDate,
      type: o.type.date,
    },
    {
      id: 'sequenceUser',
      value: sequenceUser,
      type: o.type.text,
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.antiArchive.tags,

      function(item){

        var model = o.model.aaTags
        var columns = model.getTableColumns(o,item)

        var sequence =
          _.find(o.data.antiArchive.sequences,function(sequence){
            return sequence.tag == item._id
          })

        var click =
          function(){
            o.edit.set(item,model)
            if(sequence){
              o.player.loadSequence(sequence)
            }
          }

        return {
          columns: columns,
          click: click,
        }

      }
    )

  return data

}

export function getFormFields(o,item){

  if(!item){
    var item = {}
  }

  var init = {
    public: false,
  }

  var fields = [
    {
      id: 'de',
      value: item.de,
      type: 'text',
      edit: true,
    },
    {
      id: 'en',
      value: item.en,
      type: 'text',
      edit: true,
    },
    {
      id: 'fr',
      value: item.fr,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'ru',
      value: item.ru,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'public',
      value: item.public,
      type: 'toggle',
      edit: true,
      init: init.public,
    },
    {
      id: 'inFullSequence',
      value: item.inFullSequence,
      type: 'toggle',
      edit: true,
      init: init.inFullSequence,
    },
  ]

  return fields

}

export function insertForm(o,done){

  var model = o.model.aaTags

  var d = function(item){
    div.remove()
    done(item)
  }

  var c = function(item){
    div.remove()
  }

  var div =
    $('<div>')
    .css({
      position: 'fixed',
      top: '402px',
      width: '400px',
      left: 0,
      bottom: 0,
    })
    .append(
      form(o,model,null,d,c)
    )

  o.edit.append(div)

}

export function remove(o,id,done){

  var data = o.data.antiArchive.tags
  var collection = 'aa_tags'

  var used = _.find(o.data.antiArchive.markers,{tag:id})

  if(used){
    alert('tag in use.')
    done('tag_in_use')
    return
  }

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var data = o.data.antiArchive.tags
  var collection = 'aa_tags'

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection,done)

}

export function update(o,id,changes,done){

  var data = o.data.antiArchive.tags
  var collection = 'aa_tags'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aaTags/aaTags.js